import {ChangeDetectorRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import Swal from 'sweetalert2';
import { Component, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {CustomValidators} from "src/app/utils/custom-validators";
import { AuthService } from "src/app/services/auth.service"
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;


  constructor(
    private router: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
  ) {

  }

  ngOnInit(): void {
    setTimeout(() => {
      let loading = document.querySelector('.loading');
      // @ts-ignore
      loading.classList.remove('loading--show');
    }, 200);
    this.crearFormulario();
  }

  crearFormulario(): void {
    this.loginForm = this.fb.group(
      {
        email: [ "", [ Validators.required, CustomValidators.formatEmail ] ],
        password: [ "", [ Validators.required ] ],
      }
    );
  }

  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: `${ mensaje }`,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }


  public submitLoginFormB2C(): void {
    try {
      this.authService.B2CLogin();
    } catch (e) {
      this.ventanaEmergenteError("Error al cargar el componente");
    }
  }
}
